// 1: import { RestaurantProvider, useRestaurant } from '@/app/contexts/RestaurantContext';
// 2: import { LoginPage } from '@/app/components/LoginPage';
import React from 'react';
import { RestaurantProvider, useRestaurant } from '@/app/contexts/RestaurantContext';
import { LoginPage } from '@/app/components/LoginPage';
const ServeurDashboard = React.lazy(() => import('@/app/components/ServeurDashboard').then(m => ({ default: m.ServeurDashboard })));
const CaissierDashboard = React.lazy(() => import('@/app/components/CaissierDashboard').then(m => ({ default: m.CaissierDashboard })));
const AdminDashboard = React.lazy(() => import('@/app/components/AdminDashboard').then(m => ({ default: m.AdminDashboard })));
const ClientDashboard = React.lazy(() => import('@/app/components/ClientDashboard').then(m => ({ default: m.ClientDashboard })));
const LandingPage = React.lazy(() => import('@/app/components/LandingPage').then(m => ({ default: m.LandingPage })));
const JournalLiveView = React.lazy(() => import('@/app/components/JournalLiveView').then(m => ({ default: m.JournalLiveView })));
const LivreurDashboard = React.lazy(() => import('@/app/components/LivreurDashboard').then(m => ({ default: m.LivreurDashboard })));


function AppContent() {
  const { currentUser } = useRestaurant();
  const isCapacitor = typeof window !== 'undefined' && (
    (window as any).Capacitor?.isNativePlatform ||
    window.location.href.includes('capacitor://')
  );

  // Keep the servers awake
  React.useEffect(() => {
    const ping = () => {
      fetch('https://gambitafood.onrender.com/api/tables').catch(() => {});
      fetch('https://www.gombitafood.store/api/tables').catch(() => {});
    };
    const interval = setInterval(ping, 5 * 60 * 1000); // Every 5 mins
    ping();
    return () => clearInterval(interval);
  }, []);

  const searchParams = new URLSearchParams(window.location.search);
  const viewParam = searchParams.get('view');

  if (viewParam === 'journal' && currentUser) {
    return (
      <React.Suspense fallback={<div>جاري التحميل...</div>}>
        <JournalLiveView />
      </React.Suspense>
    );
  }

  if (!currentUser) {
    if (isCapacitor) {
      return (
        <React.Suspense fallback={<div className="flex items-center justify-center h-screen">جاري التحميل...</div>}>
          <LoginPage />
        </React.Suspense>
      );
    }
    return (
      <React.Suspense fallback={<div className="flex items-center justify-center h-screen">جاري التحميل...</div>}>
        <LandingPage />
      </React.Suspense>
    );
  }

  const renderDashboard = () => {
    switch (currentUser.role) {
      case 'serveur':
        return <ServeurDashboard />;
      case 'caissier':
        if (viewParam === 'admin') {
          return <AdminDashboard />;
        }
        return <CaissierDashboard />;
      case 'admin':
        return <AdminDashboard />;
      case 'client':
        return <ClientDashboard />;
      case 'livreur':
        return <LivreurDashboard />;
      default:
        return <LoginPage />;
    }
  };

  return (
    <React.Suspense fallback={<div className="flex items-center justify-center h-screen">جاري التحميل...</div>}>
      {renderDashboard()}
    </React.Suspense>
  );
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean, error: Error | null }> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 m-4 bg-red-100 border border-red-400 text-red-700 rounded">
          <h2 className="text-lg font-bold mb-2">حدث خطأ غير متوقع</h2>
          <pre className="font-mono text-xs whitespace-pre-wrap" dir="ltr">
            {this.state.error?.toString()}
          </pre>
          <button
            className="mt-4 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            onClick={() => window.location.reload()}
          >
            تحديث الصفحة
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

import { ThemeProvider } from 'next-themes';

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider attribute="class" defaultTheme="light" forcedTheme="light" enableSystem={false}>
        <RestaurantProvider>
          <AppContent />
        </RestaurantProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
